'use client'

import { motion } from 'framer-motion'
import Image from 'next/image'
import Link from 'next/link'
import { bookDemo } from 'src/utils'

const HeroSection = () => {
  return (
    <motion.section
      data-item="hero-section"
      className="bg-white py-10 sm:py-12 overflow-hidden relative z-10"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}>
      <div className="container mx-auto px-4 flex flex-col sm:flex-row items-center justify-between">
        <motion.div
          className="w-full max-w-2xl mb-12 sm:mb-0 flex flex-col gap-4 sm:gap-6 "
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.5 }}>
          <motion.div
            className="flex flex-col  gap-4 sm:gap-6 mt-4 sm:mt-12"
            data-item="hero-text">
            <h1 className="text-2xl sm:text-4xl font-bold text-[#0a1734] leading-[1.2] sm:leading-[1.1] text-center sm:text-left mt-20 sm:mt-28">
              <span className=" sm:inline">
                Fast topline
                <br />
                Faster bottom line for your
                <br />
                Fastest growing channel{' '}
                <span className="hidden sm:inline">- Delivery</span>
              </span>
            </h1>

            <div className="flex justify-center sm:justify-start flex-wrap gap-3 sm:gap-4 mb-8 sm:mb-16 mt-10 sm:mt-6">
              <motion.button
                className="bg-lp text-white px-6 py-3 sm:py-4 rounded-lg font-semibold text-md sm:text-md hover:bg-secondary/80 transition-colors flex items-center gap-2"
                whileHover={{ scale: 1.03 }}
                whileTap={{ scale: 0.98 }}
                onClick={() => bookDemo('hero-section')}>
                Get started
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M5 12H19M19 12L12 5M19 12L12 19"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </motion.button>
            </div>
          </motion.div>

          {/* Partner logos */}
          <div
            className="mt-8 sm:mt-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:gap-8"
            data-item="hero-compliance">
            <div className="flex items-center justify-center sm:justify-start gap-10 sm:gap-16">
              <div className="flex flex-col sm:flex-row items-center sm:items-center gap-2">
                <motion.div
                  className="w-24 h-24 sm:w-24 sm:h-24 rounded-full overflow-hidden"
                  whileHover={{ scale: 1.05, transition: { duration: 0.5 } }}
                  whileTap={{ scale: 0.98 }}>
                  <Image
                    src="/v2/images/soc2-badge.png"
                    alt="SOC2 Compliance Badge"
                    width={92}
                    height={92}
                    className="w-full h-full object-cover"
                  />
                </motion.div>
              </div>
              <div className="flex flex-col sm:flex-row items-center sm:items-center gap-2">
                <motion.div
                  className="w-24 h-24 sm:w-24 sm:h-24 rounded-full flex items-center justify-center"
                  whileHover={{ scale: 1.05, transition: { duration: 0.5 } }}
                  whileTap={{ scale: 0.98 }}>
                  <Image
                    src="/v2/images/olo.svg"
                    alt="OLO"
                    width={92}
                    height={92}
                    className="w-full h-full object-cover"
                  />
                </motion.div>
              </div>
              <div className="flex flex-col sm:flex-row items-center sm:items-center gap-2">
                <Link href="https://www.suiteapp.com/LoopAI" target="_blank">
                  <motion.div
                    className="w-auto h-24 sm:h-24 rounded-full flex items-center justify-center"
                    whileHover={{ scale: 1.05, transition: { duration: 0.5 } }}
                    whileTap={{ scale: 0.98 }}>
                    <Image
                      src="/v2/images/netsuite.avif"
                      alt="Netsuite"
                      width={92}
                      height={92}
                      className="w-full h-full object-cover"
                    />
                  </motion.div>
                </Link>
              </div>
            </div>
          </div>
        </motion.div>

        <motion.div
          className="w-full hidden sm:block sm:w-[45%] relative rounded-lg mt-6 sm:mt-0"
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.4, duration: 0.5 }}>
          <motion.div
            className="relative h-[300px] sm:h-[500px] w-[240%] right-[46%] rounded-lg"
            whileHover={{ x: '-3%', transition: { duration: 0.5 } }}>
            <Image
              src="/v2/images/hero-dashboard.svg"
              alt="Loop Dashboard"
              fill
              className="object-left rounded-lg"
              priority
            />
          </motion.div>
        </motion.div>
      </div>
      <div
        className="absolute top-0 left-0 w-full h-full bg-repeat -z-10 opacity-50"
        style={{
          backgroundImage: 'url(/v2/images/dotted-pattern.svg)'
        }}
      />
    </motion.section>
  )
}

export default HeroSection
